var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 6.66797C5.33333 5.19521 6.52724 4.0013 8 4.0013C9.47276 4.0013 10.6667 5.19521 10.6667 6.66797C10.6667 8.14073 9.47276 9.33464 8 9.33464C6.52724 9.33464 5.33333 8.14073 5.33333 6.66797ZM8 5.33464C7.26362 5.33464 6.66667 5.93159 6.66667 6.66797C6.66667 7.40435 7.26362 8.0013 8 8.0013C8.73638 8.0013 9.33333 7.40435 9.33333 6.66797C9.33333 5.93159 8.73638 5.33464 8 5.33464Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.66797C2 3.35426 4.68629 0.667969 8 0.667969C11.3137 0.667969 14 3.35426 14 6.66797C14 8.35209 13.2354 9.82812 12.1949 11.1793C11.3253 12.3084 10.2124 13.4117 9.10055 14.5139C8.89024 14.7224 8.67998 14.9308 8.4714 15.1394L8 15.6108L7.5286 15.1394C7.32002 14.9308 7.10976 14.7224 6.89945 14.5139C5.78765 13.4117 4.6747 12.3084 3.80515 11.1793C2.76455 9.82812 2 8.35209 2 6.66797ZM8 2.0013C5.42267 2.0013 3.33333 4.09064 3.33333 6.66797C3.33333 7.92937 3.90211 9.12 4.86152 10.3658C5.67161 11.4176 6.70849 12.4461 7.82152 13.5502C7.8808 13.609 7.9403 13.668 8 13.7272C8.0597 13.668 8.1192 13.609 8.17848 13.5502C9.29151 12.4461 10.3284 11.4176 11.1385 10.3658C12.0979 9.12 12.6667 7.92937 12.6667 6.66797C12.6667 4.09064 10.5773 2.0013 8 2.0013Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.343b835cd9983d7dd8514abfd463bf2d.svg";
export { ForwardRef as ReactComponent };